import Vue from 'vue'
import App from './App.vue'

import './assets/common.less'
// 引入 axios
import axios from 'axios'
import dataV from '@jiaminghi/data-view'
import api from '../src/assets/index'
// 将 axios 挂载到 Vue 上
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.prototype.$api = api.commonUrl

Vue.use(dataV)

new Vue({
  render: h => h(App)
}).$mount('#app')
